import type { ReactNode } from "react";
import { TableLoadingOverlay } from "@its-engineering-and-development/ui-foundation/components";
import type { TablePageInfo } from "@its-engineering-and-development/ui-foundation/components";
import { DataTablePagination } from "@/components/base/data-table/data-table";

export function PolicyLoadingPlaceholder({ label = "Loading…" }: { label?: string }) {
    return (
        <div className="flex min-h-[180px] items-center justify-center rounded-xl border border-gray-200 bg-white">
            <span className="text-sm text-gray-400">{label}</span>
        </div>
    );
}

export function PolicyPageError({ message }: { message: string }) {
    return <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{message}</div>;
}

export function PolicyTableShell({
    children,
    minWidth = "900px",
    pageInfo,
    onPageChange,
    isLoading = false,
    loadingLabel = "Loading…",
}: {
    children: ReactNode;
    minWidth?: string;
    pageInfo?: TablePageInfo | null;
    onPageChange?: (page: number) => void;
    isLoading?: boolean;
    loadingLabel?: string;
}) {
    return (
        <div className="relative overflow-hidden rounded-xl border border-gray-200 bg-white">
            <TableLoadingOverlay isLoading={isLoading} label={loadingLabel} />
            <div className="overflow-x-auto">
                <table className="w-full border-collapse text-sm" style={{ minWidth }}>
                    {children}
                </table>
            </div>

            {pageInfo && onPageChange && <DataTablePagination pageInfo={pageInfo} onPageChange={onPageChange} isLoadingPage={isLoading} />}
        </div>
    );
}

export function PolicyTableEmptyState({ colSpan, message }: { colSpan: number; message: string }) {
    return (
        <tr>
            <td colSpan={colSpan} className="px-4 py-12 text-center text-sm text-gray-500">
                {message}
            </td>
        </tr>
    );
}
